/**
 * @generated SignedSource<<f705d9ad60f7687d8697c1b727b972cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type licensesTable_AccountFragment$data = {
  readonly extension: {
    readonly licenses?: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"licensesTable_LicenseFragment">;
        };
      } | null> | null;
    };
  } | null;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "licensesTable_AccountFragment";
};
export type licensesTable_AccountFragment$key = {
  readonly " $data"?: licensesTable_AccountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"licensesTable_AccountFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "licensesTable_AccountFragment"
};

(node as any).hash = "a3e8593773dee4e41c64e209e4f82640";

export default node;
